module.exports = __webpack_public_path__ + "img/SS_Facility_Google-Map-Pin_Red.c4f6f202.png";